import { render, staticRenderFns } from "./YandexCaptcha.vue?vue&type=template&id=5c869b9a"
import script from "./YandexCaptcha.vue?vue&type=script&lang=js"
export * from "./YandexCaptcha.vue?vue&type=script&lang=js"
import style0 from "./YandexCaptcha.vue?vue&type=style&index=0&id=5c869b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports